// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"294":"1e38c033","453":"8701dc61","908":"04da99cf"}[chunkId] + ".chunk.js";
};